export enum ColoredIconTypesEnum {
    UNKNOWN = 'unknown',
    DIAMOND = 'diamond',
    REFRESH = 'refresh',
}
